import { io } from "socket.io-client";

const baseurl = process.env.REACT_APP_API_BASE_URL;

let socket = null;

export const initializeSocket = (userId) => {
  if (!socket) {
    socket = io(baseurl, {
      transports: ["websocket"],
      query: { userId },
    });

    socket.on("connect", () => {
      console.log("🔗 Socket Connected:", socket.id);
      // localStorage.setItem('socketId', JSON.stringify(socket))
    });

    socket.on("disconnect", () => {
      console.log("❌ Socket Disconnected");
    });
  }
  return socket;
};

export const getSocket = () => {
  if (!socket) {
    console.warn(
      "⚠️ Socket not initialized! Call initializeSocket(userId) first."
    );
  }
  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
    console.log("🔌 Socket disconnected manually");
  }
};
